// extracted by mini-css-extract-plugin
export var notificationHost = "_ky-0";